import { useTranslation } from 'react-i18next';
import { toUpper, isEmpty, isNumber } from 'lodash';

export function useValueByConnectivity() {
  const { t } = useTranslation();

  const tcvalue = (value, connectivity) => {
    // handles: '<string>', '5', 0, 12
    if (!isEmpty(value) || (isNumber(value) && !isNaN(value))) {
      return value;
    }

    switch (toUpper(connectivity)) {
      case 'CONNECTED':
        return t('N/A');

      case 'NOSTATE':
        return t('N/A');

      case 'DISCONNECTED':
        return t('_ _');

      default:
        return t('_ _');
    }
  };

  const tcunit = (unit, value, connectivity) => {
    if (!isEmpty(value) || (isNumber(value) && !isNaN(value))) {
      return unit;
    }

    switch (toUpper(connectivity)) {
      case 'CONNECTED':
        return null;

      case 'NOSTATE':
        return null;

      case 'DISCONNECTED':
        return unit;

      default:
        return unit;
    }
  };

  return {
    tcvalue,
    tcunit,
  };
}
